import * as React from "react";
import { Helmet } from "react-helmet";

import { AVAILABLE_COUNTRIES } from "@typings/globals";

import GlobalStyle from "@ui/style";
import { Main } from "@ui/Atoms/Main/Main";
import { ErrorBoundary } from "@ui/Atoms";
import { ErrorFallback } from "@ui/Molecules";

interface Props {
  country: AVAILABLE_COUNTRIES;
  children: React.ReactNode;
  header: React.ReactElement;
  loading?: React.ReactElement;
  footer: React.ReactElement | null;
  bottomNavigation?: React.ReactElement;
  somethingWentWrongText: string;
  appCrashExplanationText: string;
  titleTemplate: string;
  title: string;
}

const DefaultLayout = React.memo((props: Props) => {
  return (
    <React.Fragment>
      <Helmet titleTemplate={props.titleTemplate}>
        <title>{props.title || "Home cleaning ladies"}</title>
      </Helmet>
      <GlobalStyle />
      {props.header}
      {props?.loading}
      <ErrorBoundary
        fallbackUi={() => (
          <ErrorFallback
            somethingWentWrongText={props.somethingWentWrongText}
            appCrashExplanationText={props.appCrashExplanationText}
          />
        )}
      >
        <Main id="main">{props.children}</Main>
      </ErrorBoundary>
      {props.bottomNavigation && props.bottomNavigation}
      {props.footer}
    </React.Fragment>
  );
});

DefaultLayout.displayName = "DefaultLayout";

export { DefaultLayout };
